/* eslint-disable react/jsx-no-bind */
/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  FlexboxGrid,
  Loader,
  Table,
  Form,
} from 'rsuite';
import { toast } from 'react-toastify';
import { Container } from '~/styles/tabela1';
import api from '~/services/api';
import InputAutocomplete from '~/components/InputAutocomplete';
import useSearchNames from '~/services/useSearchNames';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import { MdOutlinePeopleOutline } from 'react-icons/md';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { ImBlocked } from 'react-icons/im';
import CelulaAcao from './components/CelulaAcao';

import { dadosCarteira } from '../../../store/modulos/carteiraClientes/actions';
import SearchInputTable from '../../../components/SearchInputTable';
import PageHeader from '../../../components/PageHeader';
import MetricsCards from '../../../components/MetricCards';
import AdvancedFilters from '../../../components/AdvancedFilters';

const { HeaderCell, Column, Cell } = Table;

function ListaProfissionaisHabilitados() {
  const dispatch = useDispatch();
  const dadosCliente = useSelector((state) => state.carteiraClientes);
  const [nomesEstabelecimentos, setNomesEstabelecimentos] = useState([]);
  const [proSelecionado, setProSelecionado] = useState();
  const [pagina, setPagina] = useState(1);
  const [filtroProfissionais, setFiltroProfissionais] = useState('');
  const [idEstabelecimentoFiltro, setIdEstabelecimentoFiltro] = useState();
  const [desabilitar, setDesabilitar] = useState();
  const [profissional, setProfissional] = useState();
  const [carregando, setCarregando] = useState(false);
  const buscarNomesEstabelecimentos = useSearchNames(
    setNomesEstabelecimentos,
    'estabelecimentos'
  );
  const [orderBy, setOrderBy] = useState('');

  // eslint-disable-next-line no-unused-vars
  const [ano, setAno] = useState(new Date().getFullYear());

  const buscarProfissionaisHabilitados = useCallback(async () => {
    if (!idEstabelecimentoFiltro) return;
    setCarregando(true);
    try {
      const resposta = await api.get(
        `estabelecimentos/profissionais-desabilitados`,
        {
          params: {
            idEstabelecimentoFiltro,
            pagina,
            filtroProfissionais,
            proSelecionado,
            orderBy,
            ano
          },
        }
      );
      const lista = resposta.data.lista.map((i) => ({
        ...i,
      }));

      dispatch(
        dadosCarteira({
          ...resposta.data,
          profissionais: lista,
          quantidade: lista.length > 0 ? lista[0].full_count : 0,
          services: resposta.data.services,
          pro: resposta.data.pro,
        })
      );
    } catch (e) {
      toast.error(e.message);
    }
    setCarregando(false);
  }, [
    pagina,
    idEstabelecimentoFiltro,
    ano,
    filtroProfissionais,
    proSelecionado,
    orderBy,
  ]);

  useEffect(() => {
    buscarProfissionaisHabilitados();
  }, [buscarProfissionaisHabilitados]);

  useEffect(() => {
    if (dadosCliente.quantidade > 0 && dadosCliente.profissionais.length === 0) setPagina(1)
  }, [dadosCliente.quantidade]);


  function aproNull(value) {
    if (value !== '') {
      return proSelecionado;
    }
    return setProSelecionado('');
  }

  async function favoritarProfissional() {
    // setCarregando(true);
    if (!idEstabelecimentoFiltro) return
    if (!profissional) return
    try {
      await api.post('estabelecimentos/profissionais-desabilitados', {
        idProfissional: profissional.id_profissional,
        idEstabelecimento: idEstabelecimentoFiltro,
        desabilitar: desabilitar === 'Sim' ? 'Sim' : 'Não',
      });
      buscarProfissionaisHabilitados();
      toast.success('Status atualizado com sucesso!');

    } catch (error) {
      toast.error(error.message);
    }
    setCarregando(false);
  }

  useEffect(() => {
    favoritarProfissional();
  }, [desabilitar]);

  return (
    <Container>
      <PageHeader
        title="Profissionais Habilitados/Desabilitados"
        subtitle="Listagem de Profissionais Habilitados/Desabilitados"
      />
      <MetricsCards
        items={[
          {
            title: 'Total de Profissionais',
            value: dadosCliente.quantidade,
            icon: <MdOutlinePeopleOutline size="30px" />,
            background: '#EFF6FF',
            color: '#2563EB'
          },
          {
            title: 'Quantidade de Perfis Habilitados para o estabelecimento',
            value: '8.532',
            icon: <IoMdCheckmarkCircleOutline size="30px" />,
            background: '#ECFDF3',
            color: '#16A34A'
          },
          {
            title: 'Quantidade de Perfis Desabilitados para o estabelecimento',
            value: '-',
            icon: <ImBlocked size="30px" />,
            background: '#FFF7ED',
            color: '#EA580C'
          },
          {
            title: 'Quantidade de estabelecimtos Desabilitados para o perfil',
            value: '-',
            icon: <ImBlocked size='30px' />,
            background: '#FFF7ED',
            color: '#EA580C'
          },
        ]}
      />
      <AdvancedFilters
        // activeFilters={activeFilters}
        header={
          <>
            <Form layout="horizontal">
              <FlexboxGrid justify="start" align="middle" style={{ gap: '10px' }}>
                <InputAutocomplete
                  estilo={{ marginRight: '0px' }}
                  name="estabelecimento"
                  list={nomesEstabelecimentos}
                  onchange={buscarNomesEstabelecimentos}
                  setState={setIdEstabelecimentoFiltro}
                  placeholder="Cliente"
                  target="estabelecimentos"
                />
                <SearchInputTable setTextoDigitado={setFiltroProfissionais} />
              </FlexboxGrid>
            </Form>
          </>
        }
      />

      <FlexboxGrid style={{ width: '100%' }}>
        <TablePagination
          carregando={carregando}
          dados={dadosCliente.profissionais}
          quantidade={dadosCliente.quantidade || 0}
          onChangePage={setPagina}
          setOrderBy={setOrderBy}
        >

          <Column resizable width={240} sortable>
            <HeaderCell>
              <TableHeaderTooltip label='Nome Profissional' tooltip='Nome Profissional' />
            </HeaderCell>
            <Cell dataKey="nome" />
          </Column>

          <Column resizable width={150}>
            <HeaderCell>
              <TableHeaderTooltip label='Email' tooltip='Email' />
            </HeaderCell>
            <Cell dataKey="email" />
          </Column>
          <Column resizable width={220}>
            <HeaderCell>
              <TableHeaderTooltip label='CNPJ/CPF' tooltip='CNPJ/CPF' />
            </HeaderCell>
            <Cell dataKey="cpf_cnpj" />
          </Column>
          <Column resizable width={150}>
            <HeaderCell>
              <TableHeaderTooltip label='Telefone' tooltip='Telefone' />
            </HeaderCell>
            <Cell dataKey="telefone1" />
          </Column>
          <Column resizable width={100}>
            <HeaderCell>
              <TableHeaderTooltip label='Desabilitado' tooltip='Desabilitado' />
            </HeaderCell>
            <Cell dataKey="desabilitado" />
          </Column>
          <Column resizable width={160}>
            <HeaderCell>
              <TableHeaderTooltip label='Habilitar/Desabilitar' tooltip='Habilitar/Desabilitar' />
            </HeaderCell>
            <CelulaAcao dataKey="favorito" setDesabilitar={setDesabilitar} setProfissional={setProfissional} />
          </Column>
        </TablePagination>
      </FlexboxGrid>
      {carregando && <Loader center size="lg" vertical />}
    </Container>
  );
}

export default ListaProfissionaisHabilitados;
